/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Mantine
import {
	Box,
	LoadingOverlay,
	NumberFormatter,
	Text,
	Tooltip,
} from '@mantine/core';

// Styles
import classes from './Measurabilities.module.css';

// I18n
import { useTranslation } from 'react-i18next';

// Constants
import { NOT_APPLICABLE } from '@config/constants/common';

// Utils
import { truncateString } from '@utils/functions';

// Apis

// Lodash
import isNil from 'lodash/isNil';

// Types
import { getCurrencyUnit } from '@utils/currency-units';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
type RowExpansionProps = {
	additionalities: any;
	isLoading: boolean;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

export const Additionalities = (
	props: RowExpansionProps
) => {
	/* ******************************** Hooks ******************************* */
	const { t } = useTranslation();

	const { additionalities, isLoading } = props;

	const rowsAdditionality =
		Array.isArray(additionalities) &&
		additionalities.length > 0 ? (
			additionalities.map(
				(item: {
					name: string;
					id: string;
					coverage: number;
					target_euro: number;
				}) => {
					return (
						<Box key={item.id} className={classes.row}>
							<Tooltip
								disabled={
									(!isNil(item) && isNil(item.name)) ||
									(!isNil(item.name) &&
										item.name.length <= 30)
								}
								label={item.name}
							>
								<Box className={classes.divition}>
									<Text className={classes.rowText}>
										{truncateString(item.name, 30)}
									</Text>
								</Box>
							</Tooltip>
							<Box className={classes.divition}>
								<NumberFormatter
									className={classes.value}
									thousandSeparator=" "
									value={item.coverage}
									suffix={' ' + getCurrencyUnit('EUR')}
									decimalScale={2}
								/>
							</Box>

							<Box className={classes.divition}>
								<NumberFormatter
									className={classes.value}
									thousandSeparator=" "
									value={item.target_euro}
									suffix={' ' + getCurrencyUnit('EUR')}
									decimalScale={2}
								/>
							</Box>
						</Box>
					);
				}
			)
		) : (
			<Box className={classes.row}>
				<Box className={classes.divition}>
					<Text className={classes.rowText}>
						{NOT_APPLICABLE}
					</Text>
				</Box>
				<Box className={classes.divition}>
					<Text className={classes.rowText}>
						{NOT_APPLICABLE}
					</Text>
				</Box>
				<Box className={classes.divition}>
					<Text className={classes.rowText}>
						{NOT_APPLICABLE}
					</Text>
				</Box>
			</Box>
		);

	/* ******************************** RENDERING ******************************* */
	return (
		<>
			{isLoading ? (
				<Box
					pos="relative"
					className={classes.containerOverlay}
				>
					<LoadingOverlay
						visible={true}
						zIndex={1000}
						overlayProps={{ radius: 'sm', blur: 2 }}
					/>
				</Box>
			) : (
				<Box className={classes.container}>
					<Box className={classes.header}>
						<Box className={classes.divition}>
							<Text className={classes.headerText}>
								{t('global.project')}
							</Text>
						</Box>
						<Box className={classes.divition}>
							<Text className={classes.headerText}>
								{t('global.pledged_euro')}
							</Text>
						</Box>
						<Box className={classes.divition}>
							<Text className={classes.headerText}>
								{t('global.target_euro')}
							</Text>
						</Box>
					</Box>

					<Box className={classes.row}>
						{/*Additional projects rows */}
						<Box className={classes.rowsDivision}>
							{rowsAdditionality}
						</Box>
					</Box>
				</Box>
			)}
		</>
	);
};
